import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c42447d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "don-vi-map-preview" }
const _hoisted_2 = {
  key: 0,
  class: "don-vi-map-preview__empty"
}
const _hoisted_3 = {
  key: 1,
  class: "don-vi-map-preview__loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasCoordinates)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.emptyText), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: "mapContainerRef",
      class: _normalizeClass(["don-vi-map-preview__canvas", { 'is-hidden': !_ctx.hasCoordinates }])
    }, null, 2),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Đang tải vị trí... "))
      : _createCommentVNode("", true)
  ]))
}